<template>
  <v-container style="padding: 5%">
    <span
      class="mt-6 mb-2 text-center"
      :style="{display: 'flex', justifyContent: 'center', color: color, fontSize: !$vuetify.breakpoint.xs ? '28px' : '20px', fontWeight: !$vuetify.breakpoint.xs ? 500 : 700}">
      {{ $t('paymentComponent.paymentMethodTitle') }}
    </span>

    <v-row v-if="showPaymentsMethods">
      <v-col cols="12" style="display: flex; justify-content: center; place-items: center">
        <v-progress-linear
          :color="color"
          height="12"
          :value="progressLinePercent"
          rounded
          :style="{color: 'transparent', 'max-width': !$vuetify.breakpoint.xs ? '300px' : '210px'}"></v-progress-linear>
        <v-icon class="ml-4" :color="color" left dark> mdi-clock-time-eight-outline </v-icon>
        <span :style="{'font-size': !$vuetify.breakpoint.xs ? '15px' : '14px'}">{{ formatTime(timerValue) }}</span>
      </v-col>
    </v-row>

    <v-overlay v-if="errorToShow.show" class="align-start" :opacity="1" style="z-index: 1000000" color="white">
      <v-row justify="center" no-gutters style="margin-left: 15%; margin-right: 15%; margin-top: 100px">
        <v-col cols="12" class="d-flex justify-center">
          <div class="prominent-icon-wrapper">
            <div class="prominent-icon-bg" :style="{backgroundColor: errorToShow.textColor}"></div>
            <div class="prominent-icon">
              <v-icon :color="errorToShow.textColor" size="30"> {{ errorToShow.icon }} </v-icon>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="text-center mt-3">
          <span class="font-weight-bold" style="font-size: 15px; color: #333333"> {{ $t(`paymentComponent.errorMessage.${errorToShow.code}.title`) }} </span>
        </v-col>
        <v-col cols="12" class="text-center mt-2">
          <span class="font-weight-medium" style="font-size: 15px; color: #333333"> {{ $t(`paymentComponent.errorMessage.${errorToShow.code}.message`) }} </span>
        </v-col>
        <v-col cols="12" class="text-center mt-3">
          <v-btn class="white--text" elevation="0" rounded large :color="color" style="letter-spacing: normal; font-size: 15px; font-weight: 400" @click="backButtonRedirect(errorToShow.code)">
            {{ $t('paymentComponent.errorBackButton') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-overlay>

    <p
      v-if="showPaymentsMethods"
      class="font-weight-bold"
      :class="!$vuetify.breakpoint.xs ? 'mt-14' : 'mt-8'"
      :style="{display: 'flex', justifyContent: 'left', fontSize: !$vuetify.breakpoint.xs ? '18px' : '16px', color: '#333333'}">
      {{ $t('paymentComponent.selectPaymentMethodTitle') }}
    </p>

    <v-alert class="d-flex mb-5" v-if="showPaymentMethodAlert" color="#6DB9F9" text style="padding: 8px">
      <v-row align="center" justify="center" no-gutters>
        <v-col cols="auto">
          <v-icon class="mr-2" color="#333333" style="font-size: 18px"> mdi-information-variant-circle </v-icon>
        </v-col>
        <v-col>
          <span class="font-weight-regular" style="font-size: 12px; color: #333333; display: inline-block">{{ $t('paymentComponent.paymentMethodAlert') }}</span>
        </v-col>
      </v-row>
    </v-alert>

    <div v-show="showPaymentsMethods && !errorToShow.show">
      <PayMe v-if="paymeObject.active" :data="paymeObject.data" @loaded="incrementLoadedPaymentMethod()"></PayMe>
      <Yuno v-if="yunoObject.active" v-for="element in yunoObject.data" :key="element.Id_Procesador" :data="element" style="margin-top: 10px" @loaded="incrementLoadedPaymentMethod()"></Yuno>
    </div>

    <v-row v-if="!showPaymentsMethods" class="fill-height my-8" align-content="center" justify="center">
      <v-col class="text-subtitle-1 text-center" cols="12"> {{ $t(`yunoComponent.overlayMessage.${overlayMessage}`) }} </v-col>
      <v-col cols="12" sm="3"> <v-progress-linear indeterminate :color="color" height="10" striped rounded style="color: #d8d8d816"></v-progress-linear> </v-col>
    </v-row>

    <v-row v-show="!errorToShow.show">
      <v-col class="mt-1" cols="12" style="align-items: center; display: flex; justify-content: right">
        <v-btn class="mt-2" text :color="color" style="letter-spacing: normal" @click="backButton()">
          <v-icon left> mdi-chevron-left </v-icon>
          <span style="font-size: 15px">{{ $t('paymentComponent.backButton') }}</span>
        </v-btn>
      </v-col>
    </v-row>

    <div v-if="showPaymentsMethods && (brandList.length > 0)">
      <v-row no-gutters>
        <v-col>
          <span style="font-weight: 500; font-size: 13px; color: #545454"> {{ $t('paymentComponent.cardsAcceptedTitle') }}: </span>
        </v-col>
      </v-row>
      <v-row class="mt-2 justify-start align-center" no-gutters>
        <v-col class="pr-5 shrink" v-for="brand in brandList" :key="brand">
          <v-img :src="setBrandImage(brand)" contain style="width: 41px; height: auto"></v-img>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import PayMe from '@/components/PaymentMethods/PayMe'
import Yuno from '@/components/PaymentMethods/Yuno'
import {mapMutations, mapState} from 'vuex'

export default {
  name: 'FrameLeft',
  components: {
    PayMe,
    Yuno
  },
  data: () => ({
    //data
    imgSource: '',
    totalPaymentMethods: 0,
    loadedPaymentMethods: 0,
    showPaymentsMethods: false,
    showPaymentMethodAlert: false, // dejar en false para que la alerta solo se active cuando vaya un metodo alternativo de yuno
    localPaymentMethods: [],
    overlayMessage: 'loading',
    brandList: process.env.VUE_APP_BRAND_LIST ? JSON.parse(process.env.VUE_APP_BRAND_LIST) : [],
    paymeObject: {
      active: false,
      data: null
    },
    yunoObject: {
      active: false,
      data: null
    },
    //errors
    currentErrors: [],
    errorToShow: {
      textColor: '',
      buttonColor: '',
      type: '',
      icon: '',
      backButton: false,
      show: false,
      code: ''
    },
    errorsDict: {
      isPayed: {
        textColor: '#F57C00',
        buttonColor: '#F57C00',
        type: 'info',
        icon: 'mdi-information',
        backButton: true,
        show: true,
        code: 'ERR_PAYED'
      },
      hashExpired: {
        textColor: 'red',
        buttonColor: '#E57373',
        type: 'error',
        icon: 'mdi-alert',
        backButton: true,
        show: true,
        code: 'ERR_HASH_EXPIRED'
      },
      sessionExpired: {
        textColor: 'red',
        buttonColor: '#E57373',
        type: 'error',
        icon: 'mdi-alert',
        backButton: true,
        show: true,
        code: 'ERR_SESSION_EXPIRED'
      },
      paymentMethodsEmpty: {
        textColor: 'red',
        buttonColor: '#E57373',
        type: 'error',
        icon: 'mdi-alert',
        backButton: true,
        show: true,
        code: 'ERR_NO_METHODS'
      },
      paymentMethodsProblem: {
        textColor: 'red',
        buttonColor: '#E57373',
        type: 'error',
        icon: 'mdi-alert',
        backButton: true,
        show: true,
        code: 'ERR_METHODS'
      },
      rejectedGetBack: {
        backButton: false,
        show: true,
        code: 'REJECTED_GET_BACK'
      }
    }
  }),
  computed: {
    ...mapState([
      'paymentMethods',
      'isHeaders',
      'is_payed',
      'x_customerid',
      'gradientSession',
      'errorHeaders',
      'errorMethods',
      'errorNoMethods',
      'errorHashExpired',
      'color',
      'timerValue',
      'progressLinePercent',
      'sessionExpiredError',
      'x_language'
    ])
  },
  watch: {
    paymentMethods: function () {
      this.localPaymentMethods = this.paymentMethods
      this.mapJsonPaymentMethods()
    },
    isHeaders: function () {
      if (!this.errorSessionExpired) {
        this.getPaymentMethods()
      }
    },
    x_customerid: function () {
      this.imgSource = `${process.env.VUE_APP_STORAGE}${this.x_customerid}.png`
    },
    loadedPaymentMethods: function () {
      if (this.loadedPaymentMethods === this.totalPaymentMethods) {
        this.showPaymentsMethods = true
      }
    },
    errorHeaders: function () {
      this.currentErrors.push('paymentMethodsProblem')
      if (!this.errorMethods && !this.errorHashExpired && !this.sessionExpiredError && !this.is_payed) {
        this.postErrorStatus(this.errorsDict['paymentMethodsProblem'])
      }
      this.selectError()
      this.stopCountdown()
      this.stopBarCountdown()
    },
    errorNoMethods: function () {
      this.currentErrors.push('paymentMethodsEmpty')
      if (!this.errorHeaders && !this.errorHashExpired && !this.sessionExpiredError && !this.is_payed) {
        this.postErrorStatus(this.errorsDict['paymentMethodsEmpty'])
      }
      this.selectError()
      this.stopCountdown()
      this.stopBarCountdown()
    },
    errorMethods: function () {
      this.currentErrors.push('paymentMethodsProblem')
      if (!this.errorHeaders && !this.errorHashExpired && !this.sessionExpiredError && !this.is_payed) {
        this.postErrorStatus(this.errorsDict['paymentMethodsProblem'])
      }
      this.selectError()
      this.stopCountdown()
      this.stopBarCountdown()
    },
    sessionExpiredError: function () {
      this.currentErrors.push('sessionExpired')
      if (!this.errorHeaders && !this.errorMethods && !this.errorHashExpired && !this.is_payed) {
        this.postErrorStatus(this.errorsDict['sessionExpired'])
      }
      this.selectError()
    },
    errorHashExpired: function () {
      this.currentErrors.push('hashExpired')
      if (!this.errorHeaders && !this.errorMethods && !this.sessionExpiredError && !this.is_payed) {
        this.postErrorStatus(this.errorsDict['hashExpired'])
      }
      this.selectError()
      this.stopCountdown()
      this.stopBarCountdown()
    },
    is_payed: function () {
      this.currentErrors.push('isPayed')
      //this.postErrorStatus(this.errorsDict['isPayed'])
      this.selectError()
      this.stopCountdown()
      this.stopBarCountdown()
    },
    x_language: function () {
      this.$i18n.locale = this.x_language?.toLowerCase() || 'es'
    }
  },
  created() {
    this.currentErrors = []
    this.getHeaders()
    this.startCountdown()
    this.startBarCountdown()
  },
  methods: {
    ...mapMutations(['getPaymentMethods', 'getHeaders', 'postErrorStatus', 'backButtonRedirect', 'startCountdown', 'formatTime', 'startBarCountdown', 'stopCountdown', 'stopBarCountdown']),
    mapJsonPaymentMethods() {
      this.localPaymentMethods.paymentMethods.forEach((element) => {
        if (element.orchestratorName === 'Pay Me') {
          this.paymeObject.active = true
          this.paymeObject.data = element
          this.totalPaymentMethods += 1
        }
        if (element.orchestratorName === 'Yuno') {
          this.yunoObject.active = true
          this.yunoObject.data = element.processors
          this.totalPaymentMethods += element.processors.length
          this.verifyAlternativePaymentMethod(element.processors)
        }
      })
    },
    incrementLoadedPaymentMethod() {
      this.loadedPaymentMethods += 1
    },
    verifyAlternativePaymentMethod(paymentMethods) {
      for (const paymentMethod of paymentMethods) {
        if (paymentMethod.processorType !== 'CARD') {
          this.showPaymentMethodAlert = true
          return
        }
      }
    },
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
    },
    async backButton() {
      await this.postErrorStatus(this.errorsDict['rejectedGetBack'])
      this.backButtonRedirect('BACK_PAGE')
    },
    selectError() {
      if (this.currentErrors.find((errorName) => errorName === 'isPayed')) {
        this.errorToShow = this.errorsDict['isPayed']
      } else if (this.currentErrors.find((errorName) => errorName === 'paymentMethodsProblem')) {
        this.errorToShow = this.errorsDict['paymentMethodsProblem']
      } else if (this.currentErrors.find((errorName) => errorName === 'paymentMethodsEmpty')) {
        this.errorToShow = this.errorsDict['paymentMethodsEmpty']
      } else if (this.currentErrors.find((errorName) => errorName === 'hashExpired')) {
        this.errorToShow = this.errorsDict['hashExpired']
      } else if (this.currentErrors.find((errorName) => errorName === 'sessionExpired')) {
        this.errorToShow = this.errorsDict['sessionExpired']
      }
    },
    setBrandImage(brand) {
      return `${process.env.VUE_APP_STORAGE}${brand}.png`
    }
  }
}
</script>

<style scoped>
.prominent-icon-wrapper {
  position: relative;
  width: 54px;
  height: 54px;
}

.prominent-icon-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  opacity: 0.25;
}

.prominent-icon {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
